/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import * as React from "react";
import { useEffect, useState } from "react";
import AppLoading from "components/AppLoading";
import { PrerenderedComponent } from "react-prerendered-component";

export const prerenderedLoadable = (
  dynamicImport: () => Promise<{ default: React.ComponentType }>
): React.ComponentType => {
  return React.memo((props) => {
    const [promise] = useState(() => dynamicImport());

    const [children, setChildren] = useState<React.ReactElement | null>(
      <AppLoading />
    );

    useEffect(() => {
      promise.then((module) => {
        const Component = module.default;
        setChildren(<Component {...props} />);
      });
    }, [promise, props]);

    return (
      <PrerenderedComponent live={promise}>{children}</PrerenderedComponent>
    );
  });
};
